<template>
  <div class="m-3 rule-style">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'RuleWrapper',
}
</script>

<style lang="scss" scoped>
.rule-style{
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.1);
  background: white;
}
</style>
